
import { LinkButton } from '@/components/Button';
import Header from "@/components/Header";
import PageHero from "@/components/PageHero";
import Footer from "@/components/Footer";
import { Newspaper, FileText, Download, Calendar, ExternalLink, Mail, MessageSquare } from "lucide-react";

// Empty arrays since we have no press releases or mentions yet
const pressReleases: any[] = [];
const mediaMentions: any[] = [];

const Press = () => {
  return (
    <div className="min-h-screen bg-white">
      <PageHero 
        title="ALTA-X in the News"
        subtitle="News, press releases, and media resources about ALTA-X and our impact on the alternative investment landscape."
        backgroundImage="https://images.pexels.com/photos/3184292/pexels-photo-3184292.jpeg"
      />

      {/* Press Content */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-[hsl(var(--bronze-gold))]/10 mb-8">
            <Newspaper className="w-10 h-10 text-[hsl(var(--bronze-gold))]" />
          </div>
          <h2 className="text-3xl font-bold text-[hsl(var(--navy))] mb-6">Stay Tuned for Updates</h2>
          <p className="text-lg text-gray-600 mb-8 max-w-2xl mx-auto">
            We're excited to share our journey with you. While we don't have any press releases or media coverage to display yet, we're working hard on creating meaningful impact in the alternative investment space.
          </p>
          
          <div className="bg-gray-50 rounded-xl p-8 max-w-2xl mx-auto mt-12">
            <h3 className="text-xl font-semibold text-[hsl(var(--navy))] mb-4">For Media Inquiries</h3>
            <p className="text-gray-600 mb-6">
              Members of the press can contact our media relations team for more information about ALTA-X.
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-4">
              <a 
                href="mailto:press@altax.co.za" 
                className="px-6 py-3 rounded-full font-medium flex items-center justify-center bg-gray-800 text-white hover:bg-gray-700"
              >
                <Mail className="w-5 h-5 mr-2" />
                Email Our Team
              </a>
              <LinkButton 
                to="/contact" 
                variant="outline"
                className="px-6 py-3 rounded-full font-medium flex items-center justify-center"
              >
                <MessageSquare className="w-5 h-5 mr-2" />
                Contact Form
              </LinkButton>
            </div>
          </div>
        </div>
      </section>

      {/* Press Kit */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-gradient-to-r from-[hsl(var(--navy))] to-[hsl(var(--navy-dark))] rounded-2xl p-8 md:p-12 text-white">
            <div className="max-w-3xl mx-auto text-center">
              <h2 className="text-3xl font-bold mb-4">Press Kit</h2>
              <p className="text-gray-300 mb-8">
                Download our press kit for company information, logos, executive bios, and other resources for media professionals.
              </p>
              <div className="flex flex-wrap justify-center gap-4">
                <a 
                  href="/downloads/alta-x-press-kit.zip" 
                  download
                  className="px-6 py-3 rounded-full font-medium flex items-center bg-white text-[hsl(var(--navy))] hover:bg-gray-200"
                >
                  <Download className="w-5 h-5 mr-2" />
                  Download Press Kit
                </a>
                <a 
                  href="mailto:press@altax.co.za" 
                  className="px-6 py-3 rounded-full font-medium flex items-center border border-white text-white hover:bg-white/10"
                >
                  Contact Press Team
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Press;
